import { CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { CustomQuestion, CustomQuestionType, Ranking } from 'globals/store/events.data';
import { DotMenuComponent, DotMenuEvent, DotMenuItem } from '../misc/dot-menu.component';
import { CoreEntityType } from 'globals/store/share.data';
import { Dictionary } from '@ngrx/entity';
import { IconComponent } from '../icon/icon.component';
import { GreyWrapperComponent } from '../wrappers/grey-wrapper.component';
import { EntityTypeDropdownComponent } from './entity-type-dropdown.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'custom-question-manager-view',
    templateUrl: './custom-question-manager-view.html',
    styles: [`
button.add-question.secondary { background: unset !important; text-align: left; }
::ng-deep grey-wrapper.question-holder .grey-wrapper { background: white; flex-direction: row !important; align-items: center; }
.question-holder { margin-top: 10px; cursor: pointer; display: block; width: 100%; }
dot-menu { margin: 3px 0 0 3px; }
`],
    styleUrls: ['../../modules/manage/entity-drag.scss'],
    standalone: true,
    imports: [IconComponent, CommonModule, CdkDropList, DotMenuComponent, GreyWrapperComponent, EntityTypeDropdownComponent ],
})
export class CustomQuestionManagerViewComponent {
  @Input() addQuestionCopy: string = '+ ADD QUESTION'
  @Input() addTextCopy: string = '+ ADD A TEXT BOX'
  @Input() questions: CustomQuestion[] = []
  @Input() showCounts = true

  // BEGIN SPECIFIC TO ENTITY CUSTOM QUESTIONS INPUTS / OUTPUTS
  @Input() entityType: CoreEntityType
  @Input() entityTypesMap: Dictionary<Ranking> = {}
  @Input() questionCounts: Dictionary<number> = {}
  @Output() updateQuestionIds: EventEmitter<{ question: CustomQuestion, ids: string[] }> = new EventEmitter()
  // END
  
  dotMenuItems: DotMenuItem[] = [{ id: 'delete', title: 'Delete' }]

  @Output() editQuestion: EventEmitter<CustomQuestion> = new EventEmitter()
  @Output() dotMenuSelection: EventEmitter<{ dotEvent: DotMenuEvent, question: CustomQuestion }> = new EventEmitter()
  @Output() addQuestion: EventEmitter<CustomQuestionType | undefined> = new EventEmitter()
  @Output() changeIdOrder: EventEmitter<string[]> = new EventEmitter()


  dropIds(event: CdkDragDrop<CustomQuestion[]>) {
    const ids = this.questions.map(q => q.id)
    const newIds = [...ids]
    moveItemInArray(newIds, event.previousIndex, event.currentIndex)
    if (JSON.stringify(ids) === JSON.stringify(newIds)) return 
    this.changeIdOrder.emit(newIds)
  }

}

